import { initDataRaw } from '@telegram-apps/sdk-react';
import { botApi } from '../http';
import type { User } from '../model/user';

export default class UserService {
  static async getMe(): Promise<User> {
    return await botApi.get<User>('/user/me', { headers: { Authorization: initDataRaw() } });
  }

  static async logout(): Promise<User> {
    return await botApi.put<User>('/user/logout');
  }

  static async updateLanguage(languageId: number): Promise<User> {
    return await botApi.put<User>('/user/update-language', { languageId });
  }
}
